<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="450">
      <v-card>
        <v-card-text>
          <v-form ref="confirm_form" data-vv-scope="confirm_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 text-xs-center>
                <v-icon size="150" color="yellow" class="">error_outline</v-icon>
              </v-flex>
              <v-flex xs12 text-xs-center headline>
                Are you sure?
              </v-flex>
              <v-flex xs12 text-xs-center subheading mt-3>
                {{ confirmText }}
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="" flat @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" flat @click="confirm()" :loading="loading" :disabled="loading">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: ['confirmDialog', 'confirmText', 'loading'],
  data () {
    return {
      dialog: this.confirmDialog
    }
  },
  watch: {
    confirmDialog: {
      handler () {
        this.dialog = this.confirmDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('confirmDialog', this.dialog)
      }
    }
  },
  methods: {
    confirm () {
      this.$parent.$emit('confirmAction')
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/confirm-modal/ConfirmModal.vue